import { useState, useEffect } from 'react';
import M from 'materialize-css/dist/js/materialize.min';

const Application = ({ mode, level, programme1, programme2, programme3, setProgramme1, setProgramme2, setProgramme3, setMode, setLevel}) => {

    const [error, setError] = useState(null);

    useEffect(() => {
          var elems = document.querySelectorAll('select');
          M.FormSelect.init(elems, {
               dropdownOptions: {
                    coverTrigger: false, 
                    hover: true
               }
          });

        //check if programmes are different
        if(programme1 !== '' && programme1 === programme2 ) {
             setError('Please select different programme choices.');
             setProgramme2('');
        } else if (programme1 !== '' && programme1 === programme3) {
          setError('Please select different programme choices.');
          setProgramme3('');
        } else if(programme2 !== '' && programme2 === programme3) {
          setError('Please select different programme choices.');
          setProgramme3('');
        } 

        if(programme1 !== '' && programme2 !== '' && programme1 !== programme3 && programme1 !== programme2 && programme2 !== programme3 ) {
             setError(null);
        }

    }, [ programme1, programme2, programme3, setProgramme2, setProgramme3]);
    
    return ( 
          <>            
               <h5 className="title has-text-weight-bold mt-6 mb-2 grey-text text-darken-3">Choice of Study Programme</h5>
               <div className="divider mb-5"></div>
               <div className="row">
                    <div className="input-field col s12 m4 ">
                         <select onChange={(e) => setProgramme1(e.target.value)} value={programme1}>
                              <option value="" disabled>Select</option>
                              <optgroup label="Applied Art">
                                   <option value="Music">Music</option>
                                   <option value="Cosmetology">Cosmetology</option>
                                   <option value="Fashion Design">Fashion Design</option>
                                   <option value="Art and Design">Art and Design </option>
                                   <option value="Clothing">Clothing</option>
                              </optgroup>
                              <optgroup label="Applied Science">
                                   <option value="Science Technology">Science Technology</option>
                                   <option value="Horticulture">Horticulture</option>
                              </optgroup>
                              <optgroup label="Hospitality">
                                   <option value="Food and Beverage Service">Food & Beverage Service</option>
                                   <option value="Bakery Studies">Bakery Studies</option>
                                   <option value="Tourism and Hospitality Management">Tourism & Hospitality Management</option>
                                   <option value="Professional Cookery">Professional Cookery</option>        
                              </optgroup>
                              <optgroup label="Construction and Wood Technology">
                                   <option value="Brick and Block Laying">Brick and Block Laying</option>
                                   <option value="Painting and Decorating">Painting and Decorating</option>
                                   <option value="Plumbing and Drain Laying">Plumbing and Drain Laying</option>
                                   <option value="Carpentry and Joinery">Carpentry and Joinery</option>
                                   <option value="Wood Machines and Manufacturing">Wood Machines and Manufacturing</option>
                                   <option value="Construction Technology">Construction Technology</option>
                              </optgroup>
                              <optgroup label="Civil Engineering">
                                   <option value="Civil Engineering">Civil Engineering</option>
                                   <option value="Quantity Surveying Engineering">Quantity Surveying Engineering</option>
                                   <option value="Water Resources and Irrigation Engineering">Water Resources & Irrigation Engineering</option>
                              </optgroup>
                              <optgroup label="Automotive">
                                   <option value="Motor Vehicle Body Repairs + Refinishing">Motor Vehicle Body Repairs + Refinishing</option>
                                   <option value="Motor Vehicle Mechanics">Motor Vehicle Mechanics</option>
                                   <option value="Automobile Electrics and Electronics">Automobile Electrics & Electronics</option>
                              </optgroup>
                              <optgroup label="Electrical">
                                   <option value="Electrical Power">Electrical Power</option>
                                   <option value="Computer Systems">Computer Systems</option>
                                   <option value="Communication Systems">Communication Systems</option>
                              </optgroup>
                              <optgroup label="Mechanical">
                                   <option value="Diesel Plant Fitting">Diesel Plant Fitting</option>
                                   <option value="Fabrication Engineering">Fabrication Engineering</option>
                                   <option value="Machine Shop Engineering">Machine Shop Engineering</option>
                                   <option value="Refrigeration and Air Conditioning">Refrigeration & Air Conditioning</option>
                                   <option value="Production Engineering">Production Engineering</option>
                                   <option value="Mechanical Engineering">Mechanical Engineering</option>
                              </optgroup>
                              <optgroup label="Business Studies">
                                   <option value="Accountancy">Accountancy</option>
                                   <option value="Banking and Finance">Banking and Finance</option>
                              </optgroup>
                              <optgroup label="Management Studies">
                                   <option value="Transport and Logistics Management">Transport & Logistics Management</option>
                                   <option value="Marketing Management">Marketing Management</option>
                                   <option value="Human Resources">Human Resources</option>
                                   <option value="Purchasing and Supply">Purchasing and Supply</option>
                              </optgroup>
                              <optgroup label="Office Management">
                                   <option value="Secretarial">Secretarial</option>
                                   <option value="Office Management">Office Management</option>
                              </optgroup>
                              <optgroup label="IM Systems">
                                   <option value="Information Technology">Information Technology</option>
                                   <option value="Library and Information Science">Library and Information Science</option>
                                   <option value="Records Management and Info Science">Records Management and Info Science</option>
                              </optgroup>
                              <optgroup label="Education">
                                   <option value="Further Education Trainers Certificate">Further Education Trainers Certificate</option>
                                   <option value="Further Education Trainers Diploma">Further Education Trainers Diploma</option>
                              </optgroup>
                         </select>
                         <label>Fisrt Choice:</label>
                    </div>
                    <div className="input-field col s12 m4">
                         <select  onChange={(e) => setProgramme2(e.target.value)} value={programme2}>
                              <option value="" disabled>Select</option>
                              <optgroup label="Applied Art">
                                   <option value="Music">Music</option>
                                   <option value="Cosmetology">Cosmetology</option>
                                   <option value="Fashion Design">Fashion Design</option>
                                   <option value="Art and Design">Art and Design </option>
                                   <option value="Clothing">Clothing</option>
                              </optgroup>
                              <optgroup label="Applied Science">
                                   <option value="Science Technology">Science Technology</option>
                                   <option value="Horticulture">Horticulture</option>
                              </optgroup>
                              <optgroup label="Hospitality">
                                   <option value="Food and Beverage Service">Food & Beverage Service</option>
                                   <option value="Bakery Studies">Bakery Studies</option>
                                   <option value="Tourism and Hospitality Management">Tourism & Hospitality Management</option>
                                   <option value="Professional Cookery">Professional Cookery</option>        
                              </optgroup>
                              <optgroup label="Construction and Wood Technology">
                                   <option value="Brick and Block Laying">Brick and Block Laying</option>
                                   <option value="Painting and Decorating">Painting and Decorating</option>
                                   <option value="Plumbing and Drain Laying">Plumbing and Drain Laying</option>
                                   <option value="Carpentry and Joinery">Carpentry and Joinery</option>
                                   <option value="Wood Machines and Manufacturing">Wood Machines and Manufacturing</option>
                                   <option value="Construction Technology">Construction Technology</option>
                              </optgroup>
                              <optgroup label="Civil Engineering">
                                   <option value="Civil Engineering">Civil Engineering</option>
                                   <option value="Quantity Surveying Engineering">Quantity Surveying Engineering</option>
                                   <option value="Water Resources and Irrigation Engineering">Water Resources & Irrigation Engineering</option>
                              </optgroup>
                              <optgroup label="Automotive">
                                   <option value="Motor Vehicle Body Repairs + Refinishing">Motor Vehicle Body Repairs + Refinishing</option>
                                   <option value="Motor Vehicle Mechanics">Motor Vehicle Mechanics</option>
                                   <option value="Automobile Electrics and Electronics">Automobile Electrics & Electronics</option>
                              </optgroup>
                              <optgroup label="Electrical">
                                   <option value="Electrical Power">Electrical Power</option>
                                   <option value="Computer Systems">Computer Systems</option>
                                   <option value="Communication Systems">Communication Systems</option>
                              </optgroup>
                              <optgroup label="Mechanical">
                                   <option value="Diesel Plant Fitting">Diesel Plant Fitting</option>
                                   <option value="Fabrication Engineering">Fabrication Engineering</option>
                                   <option value="Machine Shop Engineering">Machine Shop Engineering</option>
                                   <option value="Refrigeration and Air Conditioning">Refrigeration & Air Conditioning</option>
                                   <option value="Production Engineering">Production Engineering</option>
                                   <option value="Mechanical Engineering">Mechanical Engineering</option>
                              </optgroup>
                              <optgroup label="Business Studies">
                                   <option value="Accountancy">Accountancy</option>
                                   <option value="Banking and Finance">Banking and Finance</option>
                              </optgroup>
                              <optgroup label="Management Studies">
                                   <option value="Transport and Logistics Management">Transport & Logistics Management</option>
                                   <option value="Marketing Management">Marketing Management</option>
                                   <option value="Human Resources">Human Resources</option>
                                   <option value="Purchasing and Supply">Purchasing and Supply</option>
                              </optgroup>
                              <optgroup label="Office Management">
                                   <option value="Secretarial">Secretarial</option>
                                   <option value="Office Management">Office Management</option>
                              </optgroup>
                              <optgroup label="IM Systems">
                                   <option value="Information Technology">Information Technology</option>
                                   <option value="Library and Information Science">Library and Information Science</option>
                                   <option value="Records Management and Info Science">Records Management and Info Science</option>
                              </optgroup>
                              <optgroup label="Education">
                                   <option value="Further Education Trainers Certificate">Further Education Trainers Certificate</option>
                                   <option value="Further Education Trainers Diploma">Further Education Trainers Diploma</option>
                              </optgroup>
                         </select>
                         <label>Second Choice:</label>
                    </div>
                    <div className="input-field col s12 m4">
                         <select  onChange={(e) => setProgramme3(e.target.value)} value={programme3}>
                              <option value="" disabled>Select</option>
                              <optgroup label="Applied Art">
                                   <option value="Music">Music</option>
                                   <option value="Cosmetology">Cosmetology</option>
                                   <option value="Fashion Design">Fashion Design</option>
                                   <option value="Art and Design">Art and Design </option>
                                   <option value="Clothing">Clothing</option>
                              </optgroup>
                              <optgroup label="Applied Science">
                                   <option value="Science Technology">Science Technology</option>
                                   <option value="Horticulture">Horticulture</option>
                              </optgroup>
                              <optgroup label="Hospitality">
                                   <option value="Food and Beverage Service">Food & Beverage Service</option>
                                   <option value="Bakery Studies">Bakery Studies</option>
                                   <option value="Tourism and Hospitality Management">Tourism & Hospitality Management</option>
                                   <option value="Professional Cookery">Professional Cookery</option>        
                              </optgroup>
                              <optgroup label="Construction and Wood Technology">
                                   <option value="Brick and Block Laying">Brick and Block Laying</option>
                                   <option value="Painting and Decorating">Painting and Decorating</option>
                                   <option value="Plumbing and Drain Laying">Plumbing and Drain Laying</option>
                                   <option value="Carpentry and Joinery">Carpentry and Joinery</option>
                                   <option value="Wood Machines and Manufacturing">Wood Machines and Manufacturing</option>
                                   <option value="Construction Technology">Construction Technology</option>
                              </optgroup>
                              <optgroup label="Civil Engineering">
                                   <option value="Civil Engineering">Civil Engineering</option>
                                   <option value="Quantity Surveying Engineering">Quantity Surveying Engineering</option>
                                   <option value="Water Resources and Irrigation Engineering">Water Resources & Irrigation Engineering</option>
                              </optgroup>
                              <optgroup label="Automotive">
                                   <option value="Motor Vehicle Body Repairs + Refinishing">Motor Vehicle Body Repairs + Refinishing</option>
                                   <option value="Motor Vehicle Mechanics">Motor Vehicle Mechanics</option>
                                   <option value="Automobile Electrics and Electronics">Automobile Electrics & Electronics</option>
                              </optgroup>
                              <optgroup label="Electrical">
                                   <option value="Electrical Power">Electrical Power</option>
                                   <option value="Computer Systems">Computer Systems</option>
                                   <option value="Communication Systems">Communication Systems</option>
                              </optgroup>
                              <optgroup label="Mechanical">
                                   <option value="Diesel Plant Fitting">Diesel Plant Fitting</option>
                                   <option value="Fabrication Engineering">Fabrication Engineering</option>
                                   <option value="Machine Shop Engineering">Machine Shop Engineering</option>
                                   <option value="Refrigeration and Air Conditioning">Refrigeration & Air Conditioning</option>
                                   <option value="Production Engineering">Production Engineering</option>
                                   <option value="Mechanical Engineering">Mechanical Engineering</option>
                              </optgroup>
                              <optgroup label="Business Studies">
                                   <option value="Accountancy">Accountancy</option>
                                   <option value="Banking and Finance">Banking and Finance</option>
                              </optgroup>
                              <optgroup label="Management Studies">
                                   <option value="Transport and Logistics Management">Transport & Logistics Management</option>
                                   <option value="Marketing Management">Marketing Management</option>
                                   <option value="Human Resources">Human Resources</option>
                                   <option value="Purchasing and Supply">Purchasing and Supply</option>
                              </optgroup>
                              <optgroup label="Office Management">
                                   <option value="Secretarial">Secretarial</option>
                                   <option value="Office Management">Office Management</option>
                              </optgroup>
                              <optgroup label="IM Systems">
                                   <option value="Information Technology">Information Technology</option>
                                   <option value="Library and Information Science">Library and Information Science</option>
                                   <option value="Records Management and Info Science">Records Management and Info Science</option>
                              </optgroup>
                              <optgroup label="Education">
                                   <option value="Further Education Trainers Certificate">Further Education Trainers Certificate</option>
                                   <option value="Further Education Trainers Diploma">Further Education Trainers Diploma</option>
                              </optgroup>
                         </select>
                         <label>Third Choice:</label>
                    </div>
                    <div className="input-field col s12 m4">
                         <select  onChange={(e) => setMode(e.target.value)} value={mode}>
                              <option value="" disabled>Select</option>
                              <option value="Full Time">Full Time</option>
                              <option value="Part Time">Part Time</option>
                              <option value="Block Release">Block Release</option>
                              <option value="Distance/Online Learning">Distance/Online Learning</option>
                         </select>
                         <label>Preferred Mode of Study: </label>
                         </div>
                         <div className="input-field col s12 m4">
                         <select onChange={(e) => setLevel(e.target.value)} value={level}>
                              <option value="" disabled>Select</option>
                              <option value="National Certificate">National Certificate</option>
                              <option value="National Certificate">National Diploma</option>
                              <option value="Higher National Certificate">Higher National Certificate</option>
                         </select>
                         <label>Level: </label>
                    </div>
               </div>
               {
                    error && <p className="red-text text-darken-3">{error}</p>
               }
               <div className="mt-4">
                    <p className="grey-text text-darken-2"><span className="has-text-weight-bold">NB: </span>All Fields are required to proceed to the next step.</p>
               </div>        
          </>
     );
}
 
export default Application;